import React, { useState, useEffect } from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet';
import style from './WidgetsHeader.scss';
import { getLocationParam } from 'js/utils/url.util';

export const WidgetsHeader = ({ presentTabs, useTournament, onActiveTabClick, initialActiveTabName }) => {
    const t = usePortletTranslations();

    const widgetNames = [];
    const widgetDisplayNames = [];
    if (presentTabs.isLbPresent) {
        widgetNames.push('leaderboards');
        if (useTournament) {
            widgetDisplayNames.push('tournaments');
        } else {
            widgetDisplayNames.push('leaderboards');
        }
    }
    if (getLocationParam('mp') !== '0' && presentTabs.isParcelPresent) {
        widgetNames.push('mysteryParcel');
        widgetDisplayNames.push('mysteryParcel');
    }
    if (getLocationParam('ecm') !== '0' && presentTabs.isMissionsPresent) {
        widgetNames.push('missions');
        widgetDisplayNames.push('missions');
    }

    const selectInitialTab = () => {
        for (let i = 0; i < widgetNames.length; i++) {
            if (widgetNames[i] === initialActiveTabName) {
                return i;
            }
        }
        return 0;
    };

    const recalculateInitialTab = () => {
        for (let i = 0; i < widgetNames.length; i++) {
            if (widgetNames[i] === initialActiveTabName) {
                setActiveIndex(i);
            }
        }
    };

    useEffect(() => {
        recalculateInitialTab();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [presentTabs]);

    const [activeIndex, setActiveIndex] = useState(() => selectInitialTab());

    const onMenuItemClick = index => {
        setActiveIndex(index);
        onActiveTabClick(widgetNames[index]);
    };

    const listItems = widgetNames.map((elName, index) => {
        return (
            <li key={elName + index}
                onClick={() => onMenuItemClick(index)}
                className={activeIndex === index ? style.active : ''}>
                {t(widgetDisplayNames[index])}
            </li>);
    });

    return (
        <div className={style.newUIMenuWrapper} >
            <ul className={style.newUIMenuContainer}>
                {listItems}
            </ul>
        </div>
    );
};

